import { stringify } from 'querystring';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router';

import compose from 'lodash/fp/compose';
import { getIn } from 'seamless-immutable';
import styled from 'styled-components';
import { withMetrics } from '@catalogo/core-metrics';
import BuyTogether from '@catalogo/ui-americanas-mobile-buy-together';
import InfoDrawer from './components/info-drawer';
import SpecsDrawer from './components/spec-drawer';
import ProductInfo from './components/product-info';
import ProductOffer from './components/product-offer';

const hasOffers = value => !!getIn(value, ['offers', 'result'], []).length;

export const ProductMainArea = props => {
  const updateUrl = newQueryString => {
    const { history } = props;
    history.replace(`?${stringify(newQueryString)}`);
  };

  useEffect(() => {
    const { parsedQs, currentSku } = props;

    if (hasOffers(currentSku)) {
      updateUrl({
        ...parsedQs,
        ...currentSku.qs,
      });
    }
  }, []);

  const { currentSku, recData, product } = props;

  return (
    <>
      <Background>
        <ProductInfo updateUrl={updateUrl} {...props} />
        <ProductOffer {...props} />
      </Background>
      <BuyTogether currentSku={currentSku} publication={recData?.['item_page.combo']} product={product} />
      <InfoDrawer device="mobile" {...props} />
      <SpecsDrawer device="mobile" {...props} />
    </>
  );
};

const Background = styled.div`
  background: #fff;
  padding-bottom: 10px;
`;

export default compose(withRouter, withMetrics)(ProductMainArea);
